import {calcSimpleMaxPoints} from "../_common/pointsCalculationHelper";

export const calculateMaxPoints = calcSimpleMaxPoints